import React from 'react';

const BULLET_PATTERN = /^[-•]\s+/;

/**
 * Renders text that may contain bullet points as a <ul>.
 * Only lines starting with "- " or "• " are treated as bullets.
 * If no bullet lines are found, renders as plain text preserving newlines.
 */
export const renderBulletList = (
  text: string | undefined | null,
  fallback?: string
): React.ReactElement => {
  if (!text) {
    return <p>{fallback || ''}</p>;
  }

  const lines = text.split('\n').filter((line) => line.trim());
  const bullets = lines.filter((line) => BULLET_PATTERN.test(line.trim()));

  if (bullets.length === 0) {
    return <p style={{ whiteSpace: 'pre-line' }}>{text}</p>;
  }

  return (
    <ul style={{ margin: 0, paddingLeft: 20 }}>
      {bullets.map((line, i) => (
        <li key={i}>{line.trim().replace(BULLET_PATTERN, '')}</li>
      ))}
    </ul>
  );
};
